import {
    CSS3,
    Express,
    HTML5,
    Javascript,
    Mongodb,
    Nextjs,
    Nextjs2,
    Nodejs,
    Reactjs,
    map,
    main,
    food1,
    rage,
    ctSkill,
    weather,
    cart,
    form,
    social,
    kings,
    Tailwindcss,
    
  } from "./assets";
  
  export const projectStats = [
    {
      name: "Total Projects",
      value: "40+",
    },
    {
      name: "Website Design",
      value: "20+",
    },
    {
      name: "Clients worldwide",
      value: "+3",
    },
  ];
  
  export const tools = [
    {
      name: "MongoDB",
      icon: Mongodb,
    },
    {
      name: "Tailwindcss",
      icon: Tailwindcss,
    },
    {
      name: "Express",
      icon: Express,
    },
    {
      name: "React",
      icon: Reactjs,
    },
    {
      name: "NodeJs",
      icon: Nodejs,
    },
    {
      name: "NextJs",
      icon: Nextjs2,
    },
  ];
  
  export const skills = [
    {
      name: "ReactJs",
      value: 87,
      icon: Reactjs,
    },
    {
      name: "Tailwindcss",
      value: 90,
      icon: Tailwindcss,
    },
    {
      name: "NodeJs",
      value: 86,
      icon: Nodejs,
    },
    {
      name: "NextJs",
      value: 85,
      icon: Nextjs,
    },
    {
      name: "MongoDB",
      value: 50,
      icon: Mongodb,
    },
    {
      name: "CSS3",
      value: 85,
      icon: CSS3,
    },
    {
      name: "HTML5",
      value: 98,
      icon: HTML5,
    },
    {
      name: "JavaScript",
      value: 76,
      icon: Javascript,
    },
    
  ];
  
  export const projects = [
    {
      id: 1,
      title: "Kings Invoices",
      cat: "Invoice", 
      url: "https://kingsinvoices.vercel.app/",
      img: kings,
    },
    {
      id: 2,
      title: "Google map Website",
      cat: "map",
      url: "https://mapmingle.vercel.app",
      img: map,
    },
    {
      id: 3,
      title: "Rage",
      cat: "web app", 
      url: "https://rage-pro.vercel.app/",
      img: rage,
    },
    {
      id: 4,
      title: "Timetemp Website",
      cat: "Weather",
      url: "https://timetempupdate.vercel.app",
      img: weather,
    },
    {
      id: 5,
      title: "form",
      cat: "Form validation",
      url: "https://form-validation-project-one.vercel.app",
      img: form,
    },
    {
      id: 6,
      title: "Add to cart",
      cat: "cart web",
      url: "https://addto-cart-samueldoo.vercel.app",
      img: cart,
    },
    {
      id: 7,
      title: "Mountain",
      cat: "web app", 
      url: "https://ctskilltest.vercel.app/",
      img: ctSkill,
    },
    {
      id: 8,
      title: "Portfolio Website",
      cat: "",
      url: "",
      img: main,
    },
    {
      id: 9,
      title: "Social Media",
      cat: "Web App",
      url: "",
      img: social,
    },
    {
      id: 10,
      title: "Eat Well App",
      cat: "Mobile App",
      url: "",
      img: food1,
    },
  ];
  
  export const softskills = [
    "Time management",
    "Communication",
    "Empathy",
    "Teamwork",
    "Helpfulness",
    "Creativity",
    "Self-learning",
    "Accountability",
    "Problem solving",
    "Open-mindedness",
  ];
